/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { hasPermission } from "../../utils/utils";
import { EXPAND_LEFT } from "react-ladda-button";
import Button from "react-bootstrap/Button";
import { v4 as uuid } from "uuid";
import { LaddaButton } from "@advapacs/common";

interface ISensitiveModalProps {
  header: string;
  show: boolean;
  onClose: () => void;
  onConfirm: (remember?: boolean) => void;
  sensitive: boolean;
  can: Array<string>;
  permissions: Array<string>;
}

const SensitiveModal: FunctionComponent<ISensitiveModalProps> = (
  props: ISensitiveModalProps
) => {
  const { onClose, show, onConfirm, sensitive, can, header, permissions } =
    props;
  const rememberSensitiveRemind =
    localStorage.getItem("rememberSensitiveRemind") === "true";
  const { t } = useTranslation("modal");

  const [remember, setRemember] = useState(false);

  const checkPermission = (c: string[], per: string[]) => {
    return (c.length === 0 && per.length === 0) || (c && hasPermission(per, c));
  };

  if (
    sensitive &&
    checkPermission(can, permissions) &&
    !rememberSensitiveRemind
  ) {
    return (
      <>
        <Modal
          backdrop="static"
          size="sm"
          className="confirm-modal"
          id={"sensitive-modal"}
          show={show}
        >
          <Modal.Header>
            <div className="swal2-icon swal2-warning swal2-animate-warning-icon" />
            <h2 className="text-center">{header}</h2>
          </Modal.Header>
          <>
            <div className="form-group">
              <div className="text-center">
                {t("sensitive_study_confirm_sentence")}
              </div>
            </div>
            <div className="form-group">
              <div className="text-center">
                <span className="checkbox m-l-item m-r-xxs">
                  <input
                    type="checkbox"
                    className="form-input"
                    onChange={() => {
                      setRemember(!remember);
                    }}
                    checked={remember}
                  />
                </span>
                <span>{t("sensitive_study_do_not_remind")}</span>
              </div>
            </div>
          </>
          <Modal.Body />
          <Modal.Footer>
            <LaddaButton
              key={uuid()}
              type="button"
              className="btn btn-danger"
              data-style={EXPAND_LEFT}
              onClickHandler={() => {
                if (remember)
                  localStorage.setItem("rememberSensitiveRemind", "true");
                onConfirm(remember);
                onClose();
              }}
              btnName={t("general.continue")}
            />
            <Button className="btn-secondary" key={uuid()} onClick={onClose}>
              {t("cancel")}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  } else if (
    sensitive &&
    checkPermission(can, permissions) &&
    rememberSensitiveRemind
  ) {
    onConfirm();
  } else {
    onClose();
    return <></>;
  }
  return <></>;
};

export default SensitiveModal;
